const LAYOUT_RULES = {
  full: {
    pageUnits: 40,
    firstPageBase: 10.6,
    continuationBase: 6.2,
    footerUnits: 0,
    qrUnits: 0,
    receiverUnits: 4.2,
    thirdPartyUnits: 2.2,
    relatedRowUnits: 0.8,
    relatedBase: 1.4,
    noteBase: 1.5,
    noteLineUnits: 0.55,
    totalsBase: 3.2,
    totalsRowUnits: 0.62,
    inlineBannerUnits: 3.6,
    safetyUnits: 0.55,
    baseRowUnits: 0.9,
    lineUnit: 0.64,
    compactLineChars: 38,
    standardLineChars: 46,
    footerContactsUnits: 5.2,
    footerGapUnits: 0.9,
    metaChipUnits: 0.8,
    amountWordsUnits: 1.15,
  },
  compact: {
    pageUnits: 45.5,
    firstPageBase: 7.9,
    continuationBase: 4.5,
    footerUnits: 0,
    qrUnits: 0,
    receiverUnits: 3.2,
    thirdPartyUnits: 1.8,
    relatedRowUnits: 0.65,
    relatedBase: 1.4,
    noteBase: 1.2,
    noteLineUnits: 0.5,
    totalsBase: 2.8,
    totalsRowUnits: 0.54,
    inlineBannerUnits: 2.8,
    safetyUnits: 0.55,
    baseRowUnits: 0.8,
    lineUnit: 0.54,
    compactLineChars: 40,
    standardLineChars: 40,
    footerContactsUnits: 4.6,
    footerGapUnits: 0.75,
    metaChipUnits: 0.7,
    amountWordsUnits: 1,
  },
  standard: {
    pageUnits: 45,
    firstPageBase: 12,
    continuationBase: 5.1,
    footerUnits: 0,
    qrUnits: 0,
    receiverUnits: 4,
    thirdPartyUnits: 2.1,
    relatedRowUnits: 0.8,
    relatedBase: 1.5,
    noteBase: 1.2,
    noteLineUnits: 0.5,
    totalsBase: 4.8,
    totalsRowUnits: 0.58,
    inlineBannerUnits: 3.2,
    safetyUnits: 0.5,
    baseRowUnits: 0.92,
    lineUnit: 0.68,
    compactLineChars: 42,
    standardLineChars: 50,
    footerContactsUnits: 2.7,
    footerGapUnits: 0.7,
    metaChipUnits: 0,
    amountWordsUnits: 1.1,
  },
};

const TEMPLATE_LAYOUT_BY_RENDER_LAYOUT = {
  full: "completo",
  compact: "compacto",
  standard: "estandar",
};

function getRules(layout) {
  return LAYOUT_RULES[layout] || LAYOUT_RULES.full;
}

function getTemplateLayoutKey(layout) {
  return TEMPLATE_LAYOUT_BY_RENDER_LAYOUT[layout] || "completo";
}

function sanitizeLineLimit(value, fallback) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return fallback;
  }
  return Math.max(1, Math.round(numericValue));
}

function getPaginationConfig(documentData, layout, rules) {
  const settings = documentData && documentData.templateSettings
    ? documentData.templateSettings
    : {};
  const pagination = settings.pagination || {};
  const defaults = {
    linesFirstPage: Math.round(rules.pageUnits),
    linesDetailPage: Math.max(1, Math.round(rules.pageUnits - rules.continuationBase)),
    linesLastPage: Math.max(1, Math.round(rules.pageUnits - rules.continuationBase)),
  };

  return {
    layoutKey: getTemplateLayoutKey(layout),
    linesFirstPage: sanitizeLineLimit(pagination.linesFirstPage, defaults.linesFirstPage),
    linesDetailPage: sanitizeLineLimit(pagination.linesDetailPage, defaults.linesDetailPage),
    linesLastPage: sanitizeLineLimit(pagination.linesLastPage, defaults.linesLastPage),
  };
}

function isVisibleSetting(documentData, section, key) {
  const settings = (documentData && documentData.templateSettings) || {};
  const sectionData = settings.visibility && settings.visibility[section];

  if (sectionData && typeof sectionData[key] === "boolean") {
    return sectionData[key];
  }

  return true;
}

function calculateFirstPageExtras(documentData, rules) {
  let units = rules.receiverUnits;

  if (documentData.showInlineBanner) {
    units += rules.inlineBannerUnits;
  }

  if (documentData.thirdPartySale) {
    units += rules.thirdPartyUnits;
  }

  if (documentData.relatedDocuments.length) {
    units += rules.relatedBase + (documentData.relatedDocuments.length * rules.relatedRowUnits);
  }

  if (documentData.associatedDocuments.length) {
    units += rules.relatedBase + (documentData.associatedDocuments.length * rules.relatedRowUnits);
  }

  return units;
}

function calculateTailLines(documentData, layout, rules) {
  const noteLines = documentData.notes
    ? Math.max(1, documentData.notes.split("\n").filter(Boolean).length)
    : 0;
  const showPaymentStatusChip = Boolean(
    documentData.meta &&
    documentData.meta.paymentStatus &&
    isVisibleSetting(documentData, "receiver", "paymentStatus")
  );
  const showCurrencyChip = Boolean(
    documentData.meta &&
    documentData.meta.currency &&
    isVisibleSetting(documentData, "receiver", "currency")
  );
  const showMetaChips = showPaymentStatusChip || showCurrencyChip;
  const totalsUnits =
    rules.totalsBase +
    (documentData.totalRows.length * rules.totalsRowUnits) +
    (documentData.amountInWords ? rules.amountWordsUnits : 0) +
    (showMetaChips ? rules.metaChipUnits : 0);
  const notesUnits = noteLines
    ? rules.noteBase + (noteLines * rules.noteLineUnits)
    : 0;
  const footerContactsUnits = documentData.showLargeAmountResponsibles
    ? rules.footerContactsUnits
    : 0;

  if (layout === "full" || layout === "compact") {
    const footerColumnUnits =
      notesUnits +
      footerContactsUnits +
      (notesUnits && footerContactsUnits ? rules.footerGapUnits : 0);

    return Math.max(totalsUnits, footerColumnUnits);
  }

  return (
    totalsUnits +
    notesUnits +
    footerContactsUnits +
    (notesUnits && footerContactsUnits ? rules.footerGapUnits : 0)
  );
}

function getDetailVisibility(documentData, layout) {
  const items = documentData.items || [];
  const invoiceType = documentData.meta && documentData.meta.invoiceType;
  const compact = layout === "compact";

  return {
    compact,
    showItemTypeColumn: !compact && isVisibleSetting(documentData, "detail", "itemType"),
    showUnitColumn:
      !compact &&
      isVisibleSetting(documentData, "detail", "unit") &&
      items.some((item) => item.unit),
    showCodeColumn:
      !compact &&
      isVisibleSetting(documentData, "detail", "code") &&
      items.some((item) => item.code),
    showAlternateCodeColumn:
      !compact &&
      isVisibleSetting(documentData, "detail", "alternateCode") &&
      items.some((item) => item.barcode),
    showDiscountColumn:
      !compact &&
      invoiceType !== "CDD" &&
      isVisibleSetting(documentData, "detail", "discount"),
    showExemptColumn:
      !compact &&
      !["FEX", "CDD"].includes(invoiceType) &&
      isVisibleSetting(documentData, "detail", "exemptSales"),
    showNonSubjectColumn:
      !compact &&
      !["FEX", "CDD"].includes(invoiceType) &&
      isVisibleSetting(documentData, "detail", "nonSubjectSales"),
    showNonTaxedColumn:
      !compact &&
      ["FCF", "CCF", "FEX"].includes(invoiceType) &&
      isVisibleSetting(documentData, "detail", "nonTaxableSales"),
  };
}

function getDescriptionCharsPerLine(documentData, layout, rules) {
  const visibility = getDetailVisibility(documentData, layout);

  if (visibility.compact) {
    return rules.compactLineChars;
  }

  let visibleNarrowColumns = 0;
  [
    visibility.showItemTypeColumn,
    visibility.showUnitColumn,
    visibility.showCodeColumn,
    visibility.showAlternateCodeColumn,
    visibility.showDiscountColumn,
    visibility.showExemptColumn,
    visibility.showNonSubjectColumn,
    visibility.showNonTaxedColumn,
  ].forEach((isVisible) => {
    if (isVisible) {
      visibleNarrowColumns += 1;
    }
  });

  const charsPerLine = rules.standardLineChars - (visibleNarrowColumns * 4);
  return Math.max(16, charsPerLine);
}

function getItemLinesForLayout(item, documentData, layout, rules) {
  const charsPerLine = getDescriptionCharsPerLine(documentData, layout, rules);
  const normalizedLines = Number(item && item.rowUnits);
  const detailFontSize = Number(
    documentData &&
    documentData.theme &&
    documentData.theme.detailFontSizePx
  ) || 11;
  const fontScale = Math.max(0.92, Math.min(1.45, detailFontSize / 11));

  if (Number.isFinite(normalizedLines) && normalizedLines > 0) {
    return normalizedLines * fontScale;
  }

  const descriptionLength = String((item && item.description) || "").length;
  const wrappedLines = Math.max(1, Math.ceil(descriptionLength / charsPerLine));
  return (rules.baseRowUnits + ((wrappedLines - 1) * rules.lineUnit)) * fontScale;
}

function buildStaticLineUsage(documentData, layout, rules) {
  return {
    firstHeaderLines:
      rules.firstPageBase +
      calculateFirstPageExtras(documentData, rules) +
      rules.safetyUnits,
    tailLines: calculateTailLines(documentData, layout, rules),
  };
}

function buildItemEntries(documentData, layout, rules) {
  return (documentData.items || []).map((item) => ({
    item,
    lines: getItemLinesForLayout(item, documentData, layout, rules),
  }));
}

function getEntriesLines(entries = []) {
  return entries.reduce((total, entry) => total + entry.lines, 0);
}

function takeEntriesForCapacity(entries, capacity) {
  const pageEntries = [];
  let usedLines = 0;

  while (entries.length) {
    const nextEntry = entries[0];
    const nextLines = nextEntry.lines;

    if (pageEntries.length && usedLines + nextLines > capacity) {
      break;
    }

    if (!pageEntries.length && nextLines > capacity) {
      pageEntries.push(entries.shift());
      usedLines += nextLines;
      break;
    }

    if (usedLines + nextLines > capacity) {
      break;
    }

    pageEntries.push(entries.shift());
    usedLines += nextLines;
  }

  return { pageEntries, usedLines };
}

function pushPage(pages, pageEntries, usedLines, capacity, showTail = false) {
  pages.push({
    number: pages.length + 1,
    items: pageEntries.map((entry) => entry.item),
    usedUnits: usedLines,
    usedLines,
    capacity,
    showTail,
  });
}

function buildLineBasedPages(documentData, layout) {
  const rules = getRules(layout);
  const pagination = getPaginationConfig(documentData, layout, rules);
  const staticLines = buildStaticLineUsage(documentData, layout, rules);
  const entries = buildItemEntries(documentData, layout, rules);
  const pages = [];
  const firstCapacity = Math.max(
    0,
    pagination.linesFirstPage - staticLines.firstHeaderLines
  );
  const firstTailCapacity = Math.max(
    0,
    pagination.linesFirstPage - staticLines.firstHeaderLines - staticLines.tailLines
  );
  const lastCapacity = Math.max(
    0,
    pagination.linesLastPage - staticLines.tailLines
  );
  const detailCapacity = Math.max(1, pagination.linesDetailPage);

  if (getEntriesLines(entries) <= firstTailCapacity) {
    const usedLines = getEntriesLines(entries);
    pushPage(pages, entries, usedLines, firstTailCapacity, true);
    return pages;
  }

  if (entries.length) {
    const firstPage = takeEntriesForCapacity(entries, firstCapacity);
    pushPage(pages, firstPage.pageEntries, firstPage.usedLines, firstCapacity, false);
  } else {
    pushPage(pages, [], 0, firstTailCapacity, true);
    return pages;
  }

  while (entries.length) {
    const remainingLines = getEntriesLines(entries);
    const nextItemLines = entries[0].lines;

    if (remainingLines <= lastCapacity && nextItemLines <= lastCapacity) {
      const lastPage = takeEntriesForCapacity(entries, lastCapacity);
      pushPage(pages, lastPage.pageEntries, lastPage.usedLines, lastCapacity, true);
      return pages;
    }

    const detailPage = takeEntriesForCapacity(entries, detailCapacity);
    pushPage(pages, detailPage.pageEntries, detailPage.usedLines, detailCapacity, false);
  }

  if (!pages.length || !pages[pages.length - 1].showTail) {
    pushPage(pages, [], 0, lastCapacity, true);
  }

  return pages;
}

export function getDtePaginationStaticLineUsage(documentData, layout = "full") {
  const rules = getRules(layout);
  const pagination = getPaginationConfig(documentData, layout, rules);
  const staticLines = buildStaticLineUsage(documentData, layout, rules);

  return {
    ...staticLines,
    ...pagination,
    firstDetailCapacity: Math.max(
      0,
      pagination.linesFirstPage - staticLines.firstHeaderLines
    ),
    firstDetailWithTailCapacity: Math.max(
      0,
      pagination.linesFirstPage - staticLines.firstHeaderLines - staticLines.tailLines
    ),
    lastDetailCapacity: Math.max(
      0,
      pagination.linesLastPage - staticLines.tailLines
    ),
  };
}

export function paginateDteDocument(documentData, layout = "full") {
  const pages = buildLineBasedPages(documentData, layout);

  return pages.map((page, index) => ({
    ...page,
    number: index + 1,
    isFirst: index === 0,
    isLast: index === pages.length - 1,
    showReceiver: index === 0,
    showRelated: index === 0 && documentData.relatedDocuments.length > 0,
    showAssociated: index === 0 && documentData.associatedDocuments.length > 0,
    showThirdPartySale: index === 0 && Boolean(documentData.thirdPartySale),
    showTail: Boolean(page.showTail) || index === pages.length - 1,
  }));
}
